<template>
	<Modal
		:show="showViewIPF"
		content_class="col-12 col-md-9 col-lg-8 col-xl-6 view-ipf"
	>
		<template slot="content">
			<div>
				<div class="clearfix top">
					<div class="left-content f-l">
						<div class="content-title">IPF Details</div>
					</div>
					<div class="close-modal f-r" @click="closeViewIPF(0)">
						<i class="fa fa-times"></i>
					</div>
				</div>

				<div class="content" v-if="ipf && loan_account_details">
					<div class="col-12">
						<div class="card card-details">
							<div class="top">
								<div class="icon-box">
									<div class="clearfix">
										<div class="f-l">
											<img
												v-if="
													ipf.ipf_product_details
														.ipf_product_image_path &&
													ipf.ipf_product_details
														.ipf_product_image_path
														.trim !== ''
												"
												:src="`${gateway}${ipf.ipf_product_details.ipf_product_image_path}`"
												alt="Image Logo"
												class="logo"
											/>
											<img
												v-else
												src="/img/logo-1.png"
												alt=""
												class="logo"
											/>
											<!-- <img :src="getImageUrl(ipf.ipf_product_details.logo)" alt="" class="logo"> -->
										</div>
										<div class="f-l txt-box">
											<div class="product">
												{{
													ipf.ipf_product_details
														.ipf_product_name
												}}
											</div>
											<div class="bank">
												Bank:
												{{ ipf.bank_details.name }}
											</div>
										</div>
										<Dropdown
											class="fx-dropdown f-r"
											trigger="click"
											@on-click="clickAction($event)"
										>
											<div class="btn btn-red btn-sm">
												<i class="fa fa-wrench"></i>
												Actions
												<i
													class="fa fa-chevron-down"
												></i>
											</div>
											<DropdownMenu slot="list">
												<DropdownItem
													name="list_reviews"
												>
													<div class="clearfix">
														<i
															class="fa fa-receipt"
														></i>
														<div class="menu-text">
															List Reviews
														</div>
													</div>
												</DropdownItem>
												<DropdownItem name="add_review">
													<div class="clearfix">
														<i
															class="fa fa-comments"
														></i>
														<div class="menu-text">
															Add Review
														</div>
													</div>
												</DropdownItem>
												<DropdownItem
													name="update_payment_type"
												>
													<div class="clearfix">
														<i
															class="fa fa-credit-card"
														></i>
														<div class="menu-text">
															Update Payment Type
														</div>
													</div>
												</DropdownItem>
											</DropdownMenu>
										</Dropdown>
									</div>
								</div>
								<div class="detail-box">
									<div class="ref">
										Loan Ref:
										<b>{{
											ipf.ipf_details.loan_ref.toUpperCase()
										}}</b>
									</div>
									<div class="payment">
										Loan Amount:{{
											ipf.ipf_details.loan_currency
										}}
										{{
											utils.numberWithCommas(
												Math.round(
													ipf.ipf_details
														.loan_amount * 100,
												) / 100,
											)
										}}
									</div>
									<div class="payment">
										Loan Period:
										{{ ipf.ipf_details.loan_tenor }}
									</div>
									<!--   <div class="payment">Monthly Payable: {{utils.numberWithCommas(Math.round(ipf.ipf_details.monthlyPayable*100)/100)}}</div>-->
									<div class="payment">
										Preffered Payment Date:
										{{
											ipf.ipf_details
												.preffered_payment_date
										}}
									</div>

									<div class="payment">
										Total Expected Repayment:
										{{
											loan_account_details.total_expected_repayments
										}}
									</div>
									<div class="payment">
										Total Outstanding:
										{{
											loan_account_details.currency
												.currency_code
										}}
										{{
											utils.numberWithCommas(
												loan_account_details.total_outstanding,
											)
										}}
									</div>
									<div class="payment">
										Total Overdue:
										{{
											loan_account_details.currency
												.currency_code
										}}
										{{
											utils.numberWithCommas(
												Math.round(
													loan_account_details.total_overdue *
														100,
												) / 100,
											)
										}}
									</div>
									<div class="payment">
										Application Stage:
										<b>{{
											loan_account_details.loan_status
										}}</b>
									</div>
									<!-- <div class="payment">Estimated Date of Completion: {{moment(ipf.completeEstimateDate).format('Do MMM YYYY')}}</div>
                           <div class="status">Status: <b>{{ipf.status}}</b></div> -->
								</div>
							</div>

							<hr />

							<div class="bottom">
								<Form
									classBinding="row"
									:ref="IPFModel.forms.ipfPay.name"
									:forms="IPFModel.forms.ipfPay.forms"
									:form_data="IPFModel.forms.ipfPay.data"
								/>

								<!-- @click="requestIPF({ref: $refs[IPFModel.forms.ipf.name]})" -->
								<div
									class="btn btn-primary btn-long"
									:disabled="loading"
									@click="
										payIPF({
											ref: $refs[
												IPFModel.forms.ipfPay.name
											],
										})
									"
								>
									Pay
									<div class="lds-ring" v-show="loading">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</div>
							</div>
						</div>

						<div class="tab-box">
							<div class="tab-switch clearfix">
								<div
									class="tab f-l"
									:class="{ active: activeTabIPF == 1 }"
									@click="openTabIPF(1)"
								>
									Loan Details
								</div>
								<div
									class="tab f-l"
									:class="{ active: activeTabIPF == 2 }"
									@click="openTabIPF(2)"
								>
									Transations
								</div>
								<div
									class="tab f-l"
									:class="{ active: activeTabIPF == 3 }"
									@click="openTabIPF(3)"
								>
									Payment Schedule
								</div>
							</div>
							<div class="tab-content">
								<div
									class="content-1"
									v-show="activeTabIPF == 1"
								>
									<div class="insurance">Loan Details</div>

									<div
										class="card card-details details-card"
										v-for="(
											detail, i
										) of loan_details_table"
										:key="i"
									>
										<div class="title">
											{{ detail.title }}
										</div>
										<div class="row">
											<div class="col-6">
												<div class="th">ORIGINAL:</div>
											</div>
											<div class="col-6">
												<div class="tr">
													{{
														utils.numberWithCommas(
															detail.original,
														)
													}}
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-6">
												<div class="th">PAID:</div>
											</div>
											<div class="col-6">
												<div class="tr">
													{{
														utils.numberWithCommas(
															detail.paid,
														)
													}}
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-6">
												<div class="th">
													WRITTEN OFF:
												</div>
											</div>
											<div class="col-6">
												<div class="tr">
													{{
														utils.numberWithCommas(
															detail.written_off,
														)
													}}
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-6">
												<div class="th">OVERDUE:</div>
											</div>
											<div class="col-6">
												<div class="tr">
													{{
														utils.numberWithCommas(
															detail.overdue,
														)
													}}
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-6">
												<div class="th">
													OUTSTANDING:
												</div>
											</div>
											<div class="col-6">
												<div class="tr">
													{{
														utils.numberWithCommas(
															detail.outstanding,
														)
													}}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									class="content-1"
									v-show="activeTabIPF == 2"
								>
									<div class="transactions">
										<div
											class="empty"
											v-if="loanTransactions.length === 0"
										>
											No Transactions Found!
										</div>
										<div class="content-1" v-else>
											<div class="schedule">
												<div class="row title">
													<div class="col-md-3">
														<div class="txt">
															Amount
														</div>
													</div>
													<div class="col-md-3">
														<div class="txt">
															Tran Ref
														</div>
													</div>
													<div class="col-md-6">
														<div class="txt">
															Date
														</div>
													</div>
												</div>
												<div
													class="row"
													v-for="(
														s, i
													) of loanTransactions"
													:key="i"
												>
													<div class="col-md-3">
														<div class="txt">
															<b>{{
																Math.round(
																	s.tran_amount *
																		100,
																) / 100
															}}</b>
														</div>
													</div>
													<div class="col-md-3">
														<div class="txt">
															{{ s.tran_ref }}
														</div>
													</div>
													<div class="col-md-6">
														<div class="txt">
															{{
																moment(
																	s.paymentDate,
																).format(
																	'Do MMMM YYYY',
																)
															}}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									class="content-1"
									v-show="activeTabIPF == 3"
								>
									<div class="insurance">
										Payment Schedule
									</div>
									<div class="schedule">
										<div class="row title">
											<div class="col-md-4">
												<div class="txt">Date</div>
											</div>
											<div class="col-md-2">
												<div class="txt">
													Payment to Principle
												</div>
											</div>
											<div class="col-md-2">
												<div class="txt">
													Payment to Interest
												</div>
											</div>
											<div class="col-md-2">
												<div class="txt">
													Outstanding Amount
												</div>
											</div>
											<div class="col-md-2">
												<div class="txt">Status</div>
											</div>
										</div>
										<div
											class="row"
											v-for="(s, i) of payment_schedules"
											:key="i"
										>
											<div class="col-md-4">
												<div class="txt">
													{{
														moment(
															s.paymentDate,
														).format('Do MMMM YYYY')
													}}
												</div>
											</div>
											<div class="col-md-2">
												<div class="txt">
													{{
														utils.numberWithCommas(
															Math.round(
																s.paymentToPrinciple *
																	100,
															) / 100,
														)
													}}
												</div>
											</div>
											<div class="col-md-2">
												<div class="txt">
													{{
														utils.numberWithCommas(
															Math.round(
																s.paymentToInterest *
																	100,
															) / 100,
														)
													}}
												</div>
											</div>
											<div class="col-md-2">
												<div class="txt">
													{{
														getOutstandingAmount(s)
													}}
												</div>
											</div>
											<div class="col-md-2">
												<div class="txt">
													{{ s.status }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
export default {
	components: {
		Form: () => import('@/libs/clarks/components/form'),
		Modal: () => import('@/components/newportal/templates/others/modal'),
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
	},
	computed: {
		...mapGetters([
			'loading',
			'ipf',
			'loan_details_table',
			'showViewIPF',
			'loanTransactions',
			'loan_account_details',
			'IPFModel',
			'activeTabIPF',
			'payment_schedules',
		]),
	},
	data() {
		return {
			utils,
			moment,
			gateway: process.env.VUE_APP_GATEWAY,
			activeTab: 1,
		};
	},
	methods: {
		...mapActions([
			'requestIPF',
			'payIPF',
			'openTabIPF',
			'fetchIPFReviews',
			'fetchTopupOptionsUpdate',
		]),
		async clickAction(action) {
			switch (action) {
				case 'list_reviews':
					await this.fetchIPFReviews();
					this.$store.commit('showListReview', true);
					break;
				case 'update_payment_type':
					// await this.fetchTopupOptionsUpdate()
					this.$store.commit('showPaymentOption', true);
					break;
				case 'add_review':
					this.$store.commit('showAddReviews', true);
					break;
				default:
					break;
			}
		},
		closeViewIPF(type) {
			if (type === 0) {
				this.$store.commit('showViewIPF', false);
			} else if (type === 1) {
			}
		},
		getOutstandingAmount(s) {
			let due =
				s.paymentToPrinciple +
				s.paymentToInterest +
				s.feesDue +
				s.penaltiesDue;
			let payment =
				s.principalPayment +
				s.interestPayment +
				s.feePayment +
				s.penaltyPayment;

			return utils.numberWithCommas(
				Math.round(Math.abs(due - payment) * 100) / 100,
			);
		},
	},
	mounted() {},
};
</script>

<style lang="less">
@grey: #a7abbd;

.view-ipf {
	.card.details-card {
		padding: 10px;

		.title {
			font-size: 13px;
			font-weight: 600;
			text-transform: uppercase;
			margin: 0 0 10px 0;

			&.total {
				padding: -7px 0 7px 0;
				margin: -10px 0 5px -10px;
				border-bottom: solid 1px var(--border-grey);
			}
		}
		.th {
			font-size: 12px;
		}
		.tr {
			font-size: 13px;
			font-weight: 600;
			text-align: right;
		}
	}
	.insurance {
		font-weight: 600;
		font-size: 16px;
		margin: 0 0 30px 0;
	}
	.icon-box {
		.txt-box {
			margin: 20px 0 0 0;
		}
		.logo {
			width: 80px;
			height: auto;
			min-height: 20px;
			margin: 10px 10px 0 0;
		}
		.bank {
			font-size: 13px;
			font-weight: 600;
			color: var(--primary);
		}

		.product {
			color: @grey;
			font-weight: 600;
		}
	}
	.ref {
		font-size: 13px;
	}
	.empty {
		text-align: center;
		padding: 40px 0;
		font-size: 13px;
		color: var(--ne-red);
	}
	.payment {
		font-size: 14px;
		font-weight: 600;

		b {
			color: var(--primary) !important;
		}
	}
	.status {
		color: var(--ne-green);
		font-size: 14px;
		font-weight: 600;
	}

	.transactions {
		margin: 30px -30px 20px -30px;
	}
}
</style>
